"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ArrowsLoop20Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_14195_25797)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 7.29429C13.5813 5.76968 11.9097 4.75 10 4.75C7.62174 4.75 5.61283 6.33138 4.96742 8.5H6.56204C7.14071 7.17557 8.46227 6.25 10 6.25C11.5377 6.25 12.8593 7.17557 13.438 8.5H12.25V10H14.5H16V8.5V6.25H14.5V7.29429ZM10 15.25C8.09026 15.25 6.41867 14.2303 5.5 12.7057V13.75H4V11.5V10H5.5H7.75V11.5H6.56203C7.1407 12.8244 8.46226 13.75 10 13.75C11.5377 13.75 12.8593 12.8244 13.438 11.5H15.0326C14.3872 13.6686 12.3783 15.25 10 15.25Z", fill: "#868A98" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_14195_25797" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4 4)" }))));
}
function ArrowsLoop20(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ArrowsLoop20Svg, Object.assign({}, svgProps)));
}
exports.default = ArrowsLoop20;
//# sourceMappingURL=ArrowsLoop20.js.map